module.exports = __webpack_public_path__ + "img/quitProgress.c01ddc07.svg";